import { ReactComponent as FbIcon } from '../../assets/logos/fb-icon.svg'
import { ReactComponent as GoogleIcon } from '../../assets/logos/google-icon.svg'
import { ReactComponent as Dv360Icon } from '../../assets/logos/dv360-icon.svg'
import { ReactComponent as TikTokIcon } from '../../assets/logos/tt-icon.svg'

export const FACEBOOK_PLATFORM = 'fb'
export const GOOGLE_PLATFORM = 'ga'
export const DV_360_PLATFORM = 'dv360'
export const TIKTOK_PLATFORM = 'tiktok'
export const GOOGLE_AD_MANAGER_PLATFORM = 'gam'

export const FACEBOOK_PROVIDER_PLATFORM = 'facebook'
export const INSTAGRAM_PROVIDER_PLATFORM = 'instagram'
export const GOOGLE_PROVIDER_PLATFORM = 'google'
export const DV_360_PROVIDER_PLATFORM = 'dv360'
export const TIKTOK_PROVIDER_PLATFORM = 'tiktok'
export const GOOGLE_AD_MANAGER_PROVIDER_PLATFORM = 'gam'

export const PROVIDER_TO_PLATFORMS = {
  [FACEBOOK_PROVIDER_PLATFORM]: FACEBOOK_PLATFORM,
  [GOOGLE_PROVIDER_PLATFORM]: GOOGLE_PLATFORM,
  [DV_360_PROVIDER_PLATFORM]: DV_360_PLATFORM,
  [TIKTOK_PROVIDER_PLATFORM]: TIKTOK_PLATFORM,
  [GOOGLE_AD_MANAGER_PROVIDER_PLATFORM]: GOOGLE_AD_MANAGER_PLATFORM
}

export const PLATFORMS_TO_PROVIDER = {
  [FACEBOOK_PLATFORM]: FACEBOOK_PROVIDER_PLATFORM,
  [GOOGLE_PLATFORM]: GOOGLE_PROVIDER_PLATFORM,
  [DV_360_PLATFORM]: DV_360_PROVIDER_PLATFORM,
  [TIKTOK_PLATFORM]: TIKTOK_PROVIDER_PLATFORM,
  [GOOGLE_AD_MANAGER_PLATFORM]: GOOGLE_AD_MANAGER_PROVIDER_PLATFORM
}

export const PLATFORM_LABELS = {
  [FACEBOOK_PLATFORM]: 'Facebook',
  [GOOGLE_PLATFORM]: 'Google Ads',
  [DV_360_PLATFORM]: 'Display Video 360',
  [TIKTOK_PLATFORM]: 'TikTok',
  [GOOGLE_AD_MANAGER_PLATFORM]: 'Google Ad Manager'
}

export const platformList = [
  {
    label: PLATFORM_LABELS[FACEBOOK_PLATFORM],
    value: FACEBOOK_PLATFORM,
    description: 'Facebook & Instagram',
    icon: FbIcon
  },
  {
    label: PLATFORM_LABELS[GOOGLE_PLATFORM],
    value: GOOGLE_PLATFORM,
    description: 'Display & Search',
    icon: GoogleIcon
  },
  {
    label: PLATFORM_LABELS[DV_360_PLATFORM],
    value: DV_360_PLATFORM,
    description: 'Display Video 360',
    icon: Dv360Icon
  },
  {
    label: PLATFORM_LABELS[TIKTOK_PLATFORM],
    value: TIKTOK_PLATFORM,
    description: 'TikTok',
    icon: TikTokIcon
  }
]
export default platformList
